// Lightweight GA4 loader and helpers that respect cookie consent

let hasInitializedAnalytics = false

declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

function getMeasurementId(): string | undefined {
  const id = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined
  return id && id.trim().length > 0 ? id : undefined
}

export function isAnalyticsConfigured(): boolean {
  return Boolean(getMeasurementId())
}

export function hasAnalyticsInitialized(): boolean {
  return hasInitializedAnalytics
}

export function loadAnalytics(): void {
  if (hasInitializedAnalytics) return
  const measurementId = getMeasurementId()
  if (!measurementId) return

  // Inject gtag script
  const existing = document.querySelector(`script[src^="https://www.googletagmanager.com/gtag/js"]`)
  if (!existing) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
    document.head.appendChild(script)
  }

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    // @ts-ignore
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', measurementId, {
    anonymize_ip: true,
    allow_google_signals: false,
    send_page_view: false,
  })

  hasInitializedAnalytics = true
}

export function trackPageView(path: string): void {
  if (!hasInitializedAnalytics || typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
  })
}


